import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import "../css/prodView.css";
import axios from 'axios';
import ProdContent from './ProdContent';

const ProdView = () => {
    const { productName } = useParams();
    const location = useLocation();

    const { imgDirectory, docsDirectory, prod } = location.state || {};
    const [isLoading, setIsLoading] = useState(false);
    const [selectedThumbnail, setSelectedThumbnail] = useState(0);
    const [gallery, setGallery] = useState([]);
    const [desc, setDesc] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [about, setAbout] = useState([]);
    const [curProd, setCurProd] = useState(prod || null);
    const [imageDirectory, setImageDirectory] = useState(imgDirectory || "");
    const [docsDir, setDocsDir] = useState(docsDirectory || "");
    const bearerToken = localStorage.getItem('bearerToken');
    const navigate = useNavigate();

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            setIsLoading(true);

            try {
                let product = curProd;

                if (!product) {
                    product = await render();
                }

                if (!product || !product.proD_ID) {
                    console.warn("Product not found, redirecting to NotFound page.");
                    navigate("/notfound", { replace: true });
                    return;
                }

                // Fetch other data in parallel
                await Promise.all([
                    getGalleryFiles(product.proD_ID),
                    getProductFeatures(product.proD_ID),
                    getProductDocumentation(product.proD_ID)
                ]);
            } catch (error) {
                console.error("Error in fetchData:", error);
                navigate("/notfound", { replace: true });
            }

            if (isMounted) {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, []);

    const render = async () => {
        try {
            const name = await getProductByName();
            await getDirectories();

            return name;
        } catch (error) {
            console.error("Error during render():", error);
            return null;
        }
    };

    const getProductByName = async () => {
        try {
            const response = await axios.post("/Website/GetProductByName", {
                ProdName: productName
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            console.log("Product response:", response.data);

            if (response.data) {
                setCurProd(response.data);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching product by name:', error);
        }

        return null;
    };

    const getDirectories = async () => {
        try {
            const response = await axios.get("/Website/GetDirectories", {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });
            console.log("getDirectories response:", response.data);
            if (response.data) {
                setImageDirectory(response.data.imgDirectory || "");
                setDocsDir(response.data.docsDirectory || "");
            }
        } catch (error) {
            console.error('Error fetching directories:', error);
        }
    };

    const getGalleryFiles = async (prodID) => {
        if (!prodID) {
            console.warn("No prodID provided");
            return;
        }

        try {
            console.log("Fetching gallery for prodID:", prodID);

            const response = await axios.post(
                "/Website/GetGalleryImagesByPath",
                prodID,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${bearerToken}`,
                    },
                }
            );

            console.log("Gallery response:", response.data);
            setGallery(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error("Error fetching gallery files:", error);
        }
    };

    const getProductFeatures = async (prodID) => {
        if (!prodID) return;

        try {
            const response = await axios.post(
                "/Website/GetDescriptionByProdID",
                prodID,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${bearerToken}`,
                    },
                }
            );

            console.log("Product features response:", response.data);
            const arr = JSON.parse(response.data.desC_JSON || "{}");

            setDesc(arr?.list || []);
            setAbout(arr?.about || []);

            return arr;
        } catch (error) {
            console.error('Error fetching product features:', error);
        }
    };

    const getProductDocumentation = async (prodID) => {
        if (!prodID) {
            console.warn("No prodID provided for documents");
            return;
        }

        try {
            console.log("Fetching documents for prodID:", prodID);

            const response = await axios.post(
                "/Website/GetDocumentsbyProdID",
                prodID,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${bearerToken}`,
                    },
                }
            );

            //console.log("Documents response:", response.data);
            const docs = Array.isArray(response.data) ? response.data : [];
            setDocuments(docs);
            return docs;
        } catch (error) {
            console.error('Error fetching product documentation:', error);
            console.error('Error details:', error.response?.data);
        }
    };

    const handleThumbnailClick = (index) => {
        setSelectedThumbnail(index);
    };

    return (
        <div className="product-page">
            {isLoading ? (
                <Container style={{ textAlign: 'center', paddingTop: '10%' }}>
                    <span className="loader"></span>
                </Container>
            ) : (
                <>
                    <div className="product-container">
                        <div className="product-image">
                            <div className="prodView-image-container">
                                <div className="slider" style={{ transform: `translateX(-${selectedThumbnail * 100}%)` }}>
                                    {gallery.map((image, index) => (
                                        <img
                                            key={index}
                                            src={`${imageDirectory}/${image.imG_PATH}`}
                                            alt={image.imG_ID}
                                            className="main-image"
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="thumbnail-container">
                                {gallery.map((image, index) => (
                                    <div className="thumbnail-wrapper" key={index}>
                                        <img
                                            src={`${imageDirectory}/${image.imG_PATH}`}
                                            alt={image.imG_ID}
                                            className={`thumbnail ${selectedThumbnail === index ? 'selected' : ''}`}
                                            onClick={() => handleThumbnailClick(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="product-details">
                            <h2>{productName}</h2>
                            <p>{curProd?.proD_DESC || "No description available"}</p>
                        </div>
                    </div>
                    <ProdContent
                        description={desc}
                        documents={documents}
                        docsDir={docsDir}
                        about={about}
                    />
                </>
            )}
        </div>
    );
};

export default ProdView;